import { CallWithAuth } from '../actions/apiAction';
import { CREATOR_EARNINGS_METRICS } from './apiUrl';

/** Session cache for creator earnings metrics (dashboard → earnings pages). */
let cached = null; // { data, at }
let inflight = null;

const TTL_MS = 5 * 60 * 1000;

export function peekEarningsMetrics() {
  if (cached?.data && Date.now() - cached.at < TTL_MS) {
    return cached.data;
  }
  return null;
}

/**
 * Return cached earnings metrics or fetch (deduped).
 * @param {{ force?: boolean }} [opts]
 */
export async function getEarningsMetrics({ force = false } = {}) {
  if (!force) {
    const hit = peekEarningsMetrics();
    if (hit) return hit;
    if (inflight) return inflight;
  }

  inflight = (async () => {
    const res = await CallWithAuth('GET', CREATOR_EARNINGS_METRICS);
    if (!res?.data) {
      throw new Error('Failed to load earnings metrics');
    }
    cached = { data: res.data, at: Date.now() };
    return res.data;
  })();

  try {
    return await inflight;
  } finally {
    inflight = null;
  }
}

/** Prefetch on dashboard load — non-blocking. */
export function warmEarningsMetrics() {
  getEarningsMetrics().catch((err) => {
    console.warn('Earnings prefetch failed', err);
  });
}

export function clearEarningsCache() {
  cached = null;
  inflight = null;
}
